import { createContext, useContext } from 'react';
import { IPractitioner } from '../modules/unsw-fhir/Practitioner';
import { IPractitionerRole } from '../modules/unsw-fhir/PractitionerRole';

export interface IRole {
  code: string;
  display: string;
  organizationId: string;
  active: boolean | undefined;
}

export interface PractitionerContext {
  practitioner: IPractitioner | undefined;
  practitionerRoles: IPractitionerRole[] | undefined;
  setPractitioner: (Practitioner: IPractitioner | undefined) => void;
  setPractitionerRoles: (
    practitionerRoles: IPractitionerRole[] | undefined,
  ) => void;
  getDisplayName: () => string;
  getLastName: () => string;
  getFirstName: () => string;
  getGender: () => string;
  getEmail: () => string | undefined;
  getRoles: (organizationId?: string) => IRole[];
  isActive: () => boolean;
  error?: string;
  loading?: boolean;
}

const initalContext: PractitionerContext = {
  practitioner: undefined,
  practitionerRoles: undefined,
  isActive: () => false,
  setPractitionerRoles: () => {},
  setPractitioner: () => {},
  getDisplayName: () => '',
  getFirstName: () => '',
  getLastName: () => '',
  getGender: () => '',
  getRoles: () => [],
  getEmail: () => '',
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PractitionerContext =
  createContext<PractitionerContext>(initalContext);

export const usePractitioner = () => {
  const Practitioner = useContext(PractitionerContext);

  return Practitioner;
};
